export default __webpack_public_path__ + "static/media/SEA_8638.fe16380f.jpg";